import setStatusMobileUsers from './setStatusMobileUsers';
import setMoreStatusMobileUsers from './setMoreStatusMobileUsers';
import reset from './reset';

export default {
  setStatusMobileUsers,
  setMoreStatusMobileUsers,
  reset,
};
